import { filter } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Select from "react-select";
import { notification } from "src/utils/messages";
import DatePicker from "@mui/lab/DatePicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
// material
import {
  Card,
  Stack,
  Container,
  Typography,
  Button,
  Box,
  IconButton,
  Grid,
  TextField,
  Tooltip,
  Chip,
  Alert,
  CircularProgress,
  FormControl,
  MenuItem,
  Select as MuiSelect,
  Pagination,
  Divider,
  Collapse
} from "@mui/material";

// components
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import Modal from "@mui/material/Modal";

import Page from "../components/Page";
import { ChapterForm } from "../components/Form/Chapter";
import { GetChapterById } from "src/api/chapterSetting";
import { fetchallcitylist, fetchChapterListWithCoordinators } from "src/utils/common";
import {
  deleteChapter,
  chapterReActivation,
  getChapterActivityLog
} from "src/api/commonapi";
import {
  CalendarMonth,
  CheckCircleOutline,
  DeleteOutline,
  EditSharp,
  Event,
  ExpandLess,
  ExpandMore,
  LocationOn,
  Person,
  AssignmentInd,
  Refresh,
  Search,
  VisibilityRounded,
  Badge as BadgeIcon
} from "@mui/icons-material";

import { insertmeeting } from "src/api/commonapi";
import Deletemodal from "./DeleteModal";
import { CSVLink } from "react-csv";
import Label from "src/components/Label";
import TimelineOppositeContent, {
  timelineOppositeContentClasses
} from "@mui/lab/TimelineOppositeContent";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator
} from "@mui/lab";
import { useLocation, useNavigate } from "react-router-dom";
import CustomLoader from "src/commonComponents/CustomLoader";

//-----------------------------------------------------------------------------------

// Mirrors the `assignment_status` param in getChapterListWithCoordinators
const COVERAGE_OPTIONS = [
  { value: -1, label: "All Chapters" },
  { value: 3, label: "Any Empty Post" },
  { value: 0, label: "No Coordinator Yet" },
  { value: 1, label: "Some Posts Filled" },
  { value: 2, label: "All Posts Filled" }
];

const selectStyles = { menuPortal: (base) => ({ ...base, zIndex: 9999 }) };

export default function Chapter() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const location = useLocation();
  const navigate = useNavigate();

  // City ambassadors and city-locked staff can only ever see their own city
  const cityLocked =
    loginUser?.u_type == 1 ||
    (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1);
  const myCityId = cityLocked ? loginUser?.city_id : -1;
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  const [step, setStep] = useState(1);
  const [chaptId, setChaptId] = useState(null);
  const [myModal, setMyModal] = useState(false);
  const [editChapter, setEditChapterData] = useState(null);
  const [meetinglist, setMeetinglist] = useState(null);
  const [meeting_start_date, setMeeting_start_date] = useState(null);
  const [isLoading, setIsLoading] = useState(false);


  const [filter, setFilter] = useState({
    city_id: cityLocked ? loginUser?.city_id : location.state?.city || -1,
    ch_status: location.state?.ch_status ?? -1,
    assignment_status: location.state?.assignment_status ?? -1
  });
  const [searchInput, setSearchInput] = useState("");
  const [appliedSearch, setAppliedSearch] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [chapterRows, setChapterRows] = useState([]);
  const [counter, setCounter] = useState(0);
  const [listError, setListError] = useState("");
  const [expandedId, setExpandedId] = useState(null);

  let datelist = [];

  const getallchapter = useCallback(async () => {
    setIsLoading(true);
    setListError("");
    try {
      const resp = await fetchChapterListWithCoordinators({
        city_id: filter.city_id,
        ch_status: filter.ch_status,
        assignment_status: filter.assignment_status,
        search: appliedSearch,
        page,
        per_page: perPage
      });
      if (!resp) {
        setListError("Failed to fetch chapters");
        setChapterRows([]);
        setCounter(0);
      } else if (resp.status == 0) {
        setListError(resp.message || "Failed to fetch chapters");
        setChapterRows([]);
        setCounter(0);
      } else {
        setChapterRows(Array.isArray(resp.data?.data) ? resp.data.data : []);
        setCounter(Number(resp.data?.counter || 0));
      }
    } catch (e) {
      setListError(e?.response?.data?.message || e.message || "Network error");
    }
    setIsLoading(false);
  }, [filter.city_id, filter.ch_status, filter.assignment_status, appliedSearch, page, perPage]);

  useEffect(() => {
    getallchapter();
  }, [getallchapter]);

  // Re-apply location.state when the dashboard deep-links here again. Skipped on mount,
  // where useState above has already applied the same values.
  const appliedState = useRef(false);
  useEffect(() => {
    if (!appliedState.current) {
      appliedState.current = true;
      return;
    }
    if (!location.state) return;
    setPage(1);
    setFilter((prev) => ({
      ...prev,
      city_id: cityLocked ? loginUser?.city_id : location.state.city ?? prev.city_id,
      ch_status: location.state.ch_status ?? prev.ch_status,
      assignment_status: location.state.assignment_status ?? prev.assignment_status
    }));
  }, [location.state]);

  const handleSearch = () => {
    setPage(1);
    setAppliedSearch(searchInput.trim());
  };

  const handleClearFilters = () => {
    setSearchInput("");
    setAppliedSearch("");
    setPage(1);
    setPerPage(10);
    setFilter({ city_id: myCityId, ch_status: -1, assignment_status: -1 });
  };

  const getchapt = async (id) => {
    const response = await GetChapterById(id);
    if (response.status == 1) setEditChapterData(response.data);
    setStep(3);
  };
  let day;
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 4
  };

  const [citylist, setcitylist] = useState([]);

  const getallcitylist = async () => {
    setcitylist(await fetchallcitylist());
  };
  useEffect(async () => {
    getallcitylist();
  }, []);

  const getMeetingDate = (dayIndex, chapterId) => {
    setChaptId(chapterId);
    const today = new Date();
    let i = 0;
    today.setDate(today.getDate() + ((dayIndex - 1 - today.getDay() + 7) % 7) + 1);

    const d = String(today.getDate()).padStart(2, "0");
    const m = String(today.getMonth() + 1).padStart(2, "0");
    const y = today.getFullYear();

    datelist.push(`${d}-${m}-${y}`);
    for (; i < 14; i += 1) {
      today.setDate(today.getDate() + 14);
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear();

      datelist.push(`${dd}-${mm}-${yyyy}`);
    }
    setMeetinglist(datelist);
  };

  const setNewMeetingDate = (start_date = "") => {
    datelist = [];
    const today = start_date;
    if (today != "Invalid Date") {
      let i = 0;
      const d = String(start_date.getDate()).padStart(2, "0");
      const m = String(start_date.getMonth() + 1).padStart(2, "0");
      const y = start_date.getFullYear();

      datelist.push(`${d}-${m}-${y}`);
      for (; i < 14; i += 1) {
        today.setDate(today.getDate() + 14);
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const yyyy = today.getFullYear();
        datelist.push(`${dd}-${mm}-${yyyy}`);
      }
      setMeetinglist(datelist);
    }
  };

  const deletechapter = async (chpt_id) => {
    const resp = await deleteChapter(chpt_id, loginUser?.u_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      getallchapter();
      setDvisible({ mval: false, id: 0 });
    }
  };

  const expo_columns = [
    { label: "No", key: "sr" },
    { label: "City Name", key: "city_name" },
    { label: "State", key: "state_name" },
    { label: "Chapter Name", key: "chpt_name" },
    { label: "Meeting Day", key: "m_day" },
    { label: "Launch Director", key: "launch_director" },
    { label: "Launch Date", key: "launch_date" },
    { label: "Status", key: "status_label" },
    { label: "Coordinator Roles Filled", key: "filled_role_count" },
    { label: "Total Coordinator Roles", key: "total_role_count" },
    { label: "Vacant Roles", key: "vacant_role_count" },
    { label: "Unassigned", key: "unassigned_label" },
    { label: "Vacant Role Names", key: "vacant_role_names" },
    { label: "De-Active Date", key: "ch_deactive_date" }
  ];

  const setMeeting = async () => {
    const meetingdata = {
      c_id: chaptId,
      meeting: meetinglist
    };

    const jsmeetingdata = JSON.stringify(meetingdata);
    const resp = await insertmeeting(jsmeetingdata);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
  };

  const cancelModal = () => setMyModal(false);
  const [activeChapterId, setActiveChapterId] = useState(0);
  const [isOpenDeActiveModal, setIsOpenDeActiveModal] = useState(false);
  const [isOpenReDeactivateModal, setIsOpenReDeactivateModal] = useState(false);

  const handleActiveChapter = async (chapterId, activeType) => {
    if (chapterId != 0) {
      setIsLoading(true);

      let resp = await chapterReActivation({
        chapterId: chapterId,
        activeType: activeType,
        u_id: loginUser?.u_id
      });
      setIsLoading(false);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      if (resp.status == 1) {
        getallchapter();
        setActiveChapterId(0);
        setIsOpenDeActiveModal(false);
        setIsOpenReDeactivateModal(false);
      }
    } else {
      let notify = notification({
        type: "error",
        message: "Something went wrong On Active Chapter"
      });
      notify();
    }
  };

  const [isOpenChapterActionHistory, setIsOpenChapterActionHistory] = useState(false);

  const [chapterActivityLogList, setChapterActivityLogList] = useState([]);
  // The list is server-paginated, so capture the name at click time rather than looking it up later
  const [activeChapterName, setActiveChapterName] = useState("");

  // const Get Chapter History
  const getChapterHistoryById = async (chapterId, chapterName) => {
    setActiveChapterName(chapterName || "");
    let resp = await getChapterActivityLog(chapterId);
    if (resp.status == 1) {
      setChapterActivityLogList(resp.data);
    } else {
      setChapterActivityLogList([]);
    }
    setIsOpenChapterActionHistory(true);
  };

  const RenderChapterTimeLine = () => {
    return (
      <>
        <Timeline
          sx={{
            [`& .${timelineItemClasses.root}:before`]: {
              flex: 0,
              padding: 0
            }
          }}
        >
          {chapterActivityLogList &&
            chapterActivityLogList.map((item) => {
              return (
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineConnector />
                    <TimelineDot color="primary"></TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ py: "12px", px: 2 }}>
                    <Typography variant="h6" component="span">
                      {item?.date}
                    </Typography>
                    <Typography>{item?.note}</Typography>
                  </TimelineContent>
                </TimelineItem>
              );
            })}
        </Timeline>
      </>
    );
  };
  return (
    <>
      {/* Chapter De-Activate Modal */}

      <Modal
        open={isOpenDeActiveModal}
        onClose={() => {
          setActiveChapterId(0);
          setIsOpenDeActiveModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style, width: "450px" }}>
          <Typography align="center" id="modal-modal-title" variant="h4" component="h2">
            Are Your Sure ?
          </Typography>
          <div className="" style={{ margin: "10px auto auto ", textAlign: "center" }}>
            Do you want to De-Active Chapter ?
          </div>
          <hr style={{ margin: "0 auto" }} />
          <div
            style={{
              margin: "10px auto",
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                setActiveChapterId(0);
                setIsOpenDeActiveModal(false);
              }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                deletechapter(activeChapterId);
                setIsOpenDeActiveModal(false);
                setActiveChapterId(0);
              }}
            >
              Confirm
            </Button>
          </div>
        </Box>
      </Modal>

      {/* Chapter Re-Activate Modal */}
      <Modal
        open={isOpenReDeactivateModal}
        onClose={() => {
          setActiveChapterId(0);
          setIsOpenReDeactivateModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography align="center" id="modal-modal-title" variant="h4" component="h2">
            Do you want to Active Chapter ?
          </Typography>
          <div style={{ padding: "10px 30px", textAlign: "center" }}>
            <p>
              Do you want to active Member With Existing Membership Or You Want to Extend the
              Membership of the Members ?
            </p>
          </div>
          <hr />
          <div
            style={{
              margin: "10px auto",
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleActiveChapter(activeChapterId, 1)}
              disabled={isLoading}
              startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
            >
              Yes, Extend Existing Membership
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => handleActiveChapter(activeChapterId, 0)}
              disabled={isLoading}
              startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
            >
              No, Continue With Existing Membership
            </Button>
          </div>
        </Box>
      </Modal>

      {/* Chapter Activity History */}

      <Modal
        open={isOpenChapterActionHistory}
        onClose={() => {
          setActiveChapterId(0);
          setIsOpenChapterActionHistory(false);
          setChapterActivityLogList([]);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography align="center" id="modal-modal-title" variant="h5" component="h3">
            {activeChapterName} Chapter Activity
          </Typography>
          <hr style={{ marginBottom: "5px" }} />
          <div
            style={
              chapterActivityLogList.length != 0
                ? {
                  maxHeight: "400px",
                  minHeight: "400px",
                  overflowX: "hidden",
                  overflowY: "scroll"
                }
                : {
                  display: "flex",
                  maxHeight: "200px",
                  minHeight: "200px",
                  alignItems: "center",
                  justifyContent: "center"
                }
            }
          >
            {chapterActivityLogList.length != 0 ? (
              <RenderChapterTimeLine />
            ) : (
              <div>
                <Typography align="center" id="modal-modal-title" variant="h5" component="h3">
                  No Data Found
                </Typography>
              </div>
            )}
          </div>
        </Box>
      </Modal>

      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={deletechapter} />
      {/* Meetiing Modal */}
      <Modal
        open={myModal}
        onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{ marginBottom: "20px" }}
          >
            Confirm Meeting Date
          </Typography>
          <div className="row">
            <div className="col-md-4">
              <h5>Select Meeting Start Date : </h5>
              <Stack spacing={3} style={{ marginTop: "15px", marginBottom: "15px" }}>
                <LocalizationProvider dateAdapter={AdapterDateFns} style={{ marginTop: "15px" }}>
                  <DatePicker
                    type="date"
                    label="Select Meeting Start Date"
                    value={moment(meeting_start_date, "DD-MM-YYYYY").format("MM-DD-YYYY")}
                    toolbarFormat="dd-MM-yyyy"
                    inputFormat="dd-MM-yyyy"
                    onChange={(newDate) => {
                      setMeeting_start_date(moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY"));
                      setNewMeetingDate(moment(newDate, "DD-MM-YYYY")._i);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Stack>
            </div>
          </div>
          <div style={{ maxHeight: "280px" }}>
            <Grid
              container
              spacing={2}
              style={{
                padding: "20px",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              {meetinglist != null &&
                meetinglist.map((p) => (
                  <div
                    key={p}
                    item
                    style={{
                      margin: "10px",
                      boxShadow: "0 0 5px #000",
                      padding: "5px 10px",
                      borderRadius: "10px"
                    }}
                  >
                    {p}
                  </div>
                ))}
            </Grid>
          </div>
          <hr />
          <div
            style={{
              margin: "10px auto",
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <Button variant="outlined" onClick={cancelModal}>
              Close
            </Button>
            <Button variant="contained" onClick={setMeeting}>
              Confirm Date
            </Button>
          </div>
        </Box>
      </Modal>
      {/* Allocate Post moved to dedicated page: /allocate-post/:chapterId */}

      <Page title="Chapter | Local Vocal Business Group">
        <Container maxWidth="xl">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Chapter
            </Typography>
          </Stack>
          {step != 1 && (
            <Card sx={{ p: 2.5, mb: 3 }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ mb: 2, flexWrap: "wrap", gap: 1 }}
              >
                <Typography sx={{ fontWeight: 700, fontSize: "0.9rem", color: "#0f172a" }}>
                  {step === 3 ? "Edit Chapter" : "Add Chapter"}
                </Typography>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setStep(1);
                    setEditChapterData(null);
                  }}
                >
                  Back
                </Button>
              </Stack>
              <ChapterForm
                data={editChapter}
                setStep={setStep}
                step={step}
                myFunction={getallchapter}
              />
            </Card>
          )}

          {step == 1 && (
            <Card sx={{ p: 2.5 }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ mb: 2, flexWrap: "wrap", gap: 2 }}
              >
                <Box>
                  <Typography sx={{ fontWeight: 700, fontSize: "0.9rem", color: "#0f172a" }}>
                    Chapter List
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#64748b", mt: 0.5 }}>
                    Open a chapter to see which posts are still empty, and fill them from the
                    same screen.
                  </Typography>
                </Box>
                <Stack direction="row" spacing={1}>
                  {(loginUser.u_type == 0 || (loginUser.u_type == 2 && loginUser.p_user_id == 1)) && (
                    <Button variant="contained" onClick={() => setStep(2)}>
                      Add Chapter
                    </Button>
                  )}
                  <Button
                    variant="outlined"
                    startIcon={isLoading ? <CircularProgress size={16} /> : <Refresh fontSize="small" />}
                    onClick={getallchapter}
                    disabled={isLoading}
                  >
                    Refresh
                  </Button>
                </Stack>
              </Stack>

              <Grid container spacing={2} alignItems="flex-end">
                <Grid item xs={12} sm={6} md={3}>
                  <Typography
                    variant="caption"
                    sx={{ fontWeight: 700, mb: 0.5, display: "block", color: "#475569" }}
                  >
                    Select City
                  </Typography>
                  <Select
                    menuPortalTarget={document.body}
                    styles={selectStyles}
                    isDisabled={cityLocked}
                    options={[
                      { value: -1, label: "All City" },
                      ...citylist.map((city) => ({
                        label: city?.city_name,
                        value: city?.city_id
                      }))
                    ]}
                    onChange={(e) => {
                      setPage(1);
                      setFilter({ ...filter, city_id: e.value });
                    }}
                    value={
                      filter.city_id === -1
                        ? { value: -1, label: "All City" }
                        : citylist
                            .filter((city) => city.city_id == filter.city_id)
                            .map((city) => ({ value: city.city_id, label: city.city_name }))[0] ||
                          { value: -1, label: "All City" }
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography
                    variant="caption"
                    sx={{ fontWeight: 700, mb: 0.5, display: "block", color: "#475569" }}
                  >
                    Select Status
                  </Typography>
                  <Select
                    menuPortalTarget={document.body}
                    styles={selectStyles}
                    options={[
                      { value: -1, label: "All" },
                      { value: 0, label: "Active" },
                      { value: 1, label: "Deactive" }
                    ]}
                    onChange={(e) => {
                      setPage(1);
                      setFilter({ ...filter, ch_status: e.value });
                    }}
                    value={
                      filter.ch_status == -1
                        ? { value: -1, label: "All" }
                        : filter.ch_status == 0
                          ? { value: 0, label: "Active" }
                          : { value: 1, label: "Deactive" }
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography
                    variant="caption"
                    sx={{ fontWeight: 700, mb: 0.5, display: "block", color: "#475569" }}
                  >
                    Posts Filled
                  </Typography>
                  <Select
                    menuPortalTarget={document.body}
                    styles={selectStyles}
                    options={COVERAGE_OPTIONS}
                    onChange={(e) => {
                      setPage(1);
                      setFilter({ ...filter, assignment_status: e.value });
                    }}
                    value={
                      COVERAGE_OPTIONS.find((o) => o.value === filter.assignment_status) ||
                      COVERAGE_OPTIONS[0]
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography
                    variant="caption"
                    sx={{ fontWeight: 700, mb: 0.5, display: "block", color: "#475569" }}
                  >
                    Search Chapter
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    autoComplete="off"
                    type="text"
                    placeholder="Chapter, city or director"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleSearch();
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Stack direction="row" spacing={1} sx={{ height: 40 }}>
                    <Button
                      variant="contained"
                      startIcon={<Search fontSize="small" />}
                      onClick={handleSearch}
                      disabled={isLoading}
                    >
                      Search
                    </Button>
                    <Button variant="outlined" onClick={handleClearFilters} disabled={isLoading}>
                      Clear
                    </Button>
                  </Stack>
                </Grid>
              </Grid>

              {(filter.city_id !== -1 ||
                filter.ch_status !== -1 ||
                filter.assignment_status !== -1 ||
                appliedSearch) && (
                <Stack direction="row" spacing={1} sx={{ mt: 2, flexWrap: "wrap", gap: 1 }}>
                  <Typography variant="caption" color="text.secondary" sx={{ lineHeight: "24px" }}>
                    Active filters:
                  </Typography>
                  {filter.city_id !== -1 && (
                    <Chip
                      size="small"
                      label={`City: ${
                        citylist.find((c) => c.city_id == filter.city_id)?.city_name || filter.city_id
                      }`}
                      onDelete={() => {
                        setPage(1);
                        setFilter({ ...filter, city_id: -1 });
                      }}
                    />
                  )}
                  {filter.ch_status !== -1 && (
                    <Chip
                      size="small"
                      label={`Status: ${filter.ch_status === 0 ? "Active" : "Deactive"}`}
                      onDelete={() => {
                        setPage(1);
                        setFilter({ ...filter, ch_status: -1 });
                      }}
                    />
                  )}
                  {filter.assignment_status !== -1 && (
                    <Chip
                      size="small"
                      color="primary"
                      label={
                        COVERAGE_OPTIONS.find((o) => o.value === filter.assignment_status)?.label
                      }
                      onDelete={() => {
                        setPage(1);
                        setFilter({ ...filter, assignment_status: -1 });
                      }}
                    />
                  )}
                  {appliedSearch && (
                    <Chip
                      size="small"
                      label={`Search: ${appliedSearch}`}
                      onDelete={() => {
                        setSearchInput("");
                        setAppliedSearch("");
                        setPage(1);
                      }}
                    />
                  )}
                </Stack>
              )}

              <Box sx={{ mt: 2 }}>
                {listError ? (
                  <Alert severity="error" sx={{ borderRadius: 2 }}>
                    {listError}
                  </Alert>
                ) : isLoading && chapterRows.length === 0 ? (
                  <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                    <CustomLoader />
                  </Box>
                ) : chapterRows.length === 0 ? (
                  <Box
                    sx={{
                      p: 4,
                      textAlign: "center",
                      border: "1px dashed #cbd5e1",
                      bgcolor: "#f8fafc",
                      borderRadius: 2
                    }}
                  >
                    <Typography variant="h6" color="text.secondary">
                      No chapters found
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {filter.city_id !== -1 ||
                      filter.ch_status !== -1 ||
                      filter.assignment_status !== -1 ||
                      appliedSearch
                        ? "Try clearing or widening the filters"
                        : "No chapters have been created yet"}
                    </Typography>
                  </Box>
                ) : (
                  <>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ mb: 1.5, flexWrap: "wrap", gap: 1 }}
                    >
                      <Typography sx={{ fontWeight: 700, fontSize: "0.9rem", color: "#0f172a" }}>
                        Chapters
                      </Typography>
                      <Button className="btn btn-export" style={{ margin: 0 }}>
                        <CSVLink
                          data={chapterRows.map((r, i) => ({
                            sr: (page - 1) * perPage + i + 1,
                            city_name: r.city_name,
                            state_name: r.state_name,
                            chpt_name: r.chpt_name,
                            m_day: r.m_day,
                            launch_director: r.launch_director,
                            launch_date: r.launch_date,
                            status_label: r.ch_status === 0 ? "Active" : "Deactive",
                            filled_role_count: r.filled_role_count,
                            total_role_count: r.total_role_count,
                            vacant_role_count: r.vacant_role_count,
                            unassigned_label: r.is_unassigned === 1 ? "Yes" : "No",
                            vacant_role_names: (r.roles_breakdown || [])
                              .filter((b) => b.is_vacant)
                              .map((b) => b.role_name)
                              .join(" | "),
                            ch_deactive_date: r.ch_deactive_date || ""
                          }))}
                          headers={expo_columns}
                          filename={"ChapterList.csv"}
                          className="btn btn-primary test"
                          target="_blank"
                        >
                          Export CSV
                        </CSVLink>
                      </Button>
                    </Stack>
                    <Typography
                      variant="caption"
                      sx={{ color: "#94a3b8", display: "block", mb: 1.5 }}
                    >
                      Click any chapter to see which of its posts are still waiting for someone.
                      The button below downloads the chapters shown on this page.
                    </Typography>

                    <Grid container spacing={3} alignItems="stretch">
                      {chapterRows.map((row, idx) => {
                        const expanded = expandedId === row.chpt_id;
                        const vacantRoles = (row.roles_breakdown || []).filter((b) => b.is_vacant);
                        const filledRoles = (row.roles_breakdown || []).filter((b) => !b.is_vacant);
                        const isUnassigned = row.is_unassigned === 1;
                        const fullyStaffed = row.vacant_role_count === 0;
                        const railColor = isUnassigned
                          ? "#f59e0b"
                          : fullyStaffed
                            ? "#22c55e"
                            : "#fbbf24";

                        return (
                          <Grid item xs={12} sm={6} md={6} lg={4} key={row.chpt_id}>
                            <Card
                              sx={{
                                borderRadius: 3,
                                border: "1px solid #e2e8f0",
                                borderLeft: `3px solid ${railColor}`,
                                overflow: "hidden",
                                display: "flex",
                                flexDirection: "column",
                                height: "100%",
                                transition: "all 0.2s ease",
                                "&:hover": {
                                  transform: "translateY(-3px)",
                                  boxShadow:
                                    "0 8px 24px rgba(15,23,42,0.08), 0 2px 8px rgba(15,23,42,0.06)",
                                  borderColor: "#cbd5e1"
                                }
                              }}
                            >
                              <Box sx={{ p: 2, pb: 1.6, flexGrow: 1 }}>
                                <Stack
                                  direction="row"
                                  alignItems="flex-start"
                                  spacing={1.6}
                                  sx={{ mb: 1.5 }}
                                >
                                  <Box
                                    sx={{
                                      width: 28,
                                      height: 28,
                                      borderRadius: "50%",
                                      bgcolor: "#fffbeb",
                                      border: "1px solid #fde68a",
                                      color: "#92400e",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontSize: "0.72rem",
                                      fontWeight: 700,
                                      flexShrink: 0
                                    }}
                                  >
                                    {(page - 1) * perPage + idx + 1}
                                  </Box>
                                  <Box sx={{ minWidth: 0, flexGrow: 1 }}>
                                    <Typography
                                      sx={{
                                        fontWeight: 800,
                                        fontSize: "0.95rem",
                                        color: "#0f172a",
                                        lineHeight: 1.25
                                      }}
                                    >
                                      {row.chpt_name}
                                    </Typography>
                                    <Stack
                                      direction="row"
                                      spacing={0.5}
                                      alignItems="center"
                                      sx={{ color: "#64748b", mt: 0.3 }}
                                    >
                                      <LocationOn sx={{ fontSize: 14 }} />
                                      <Typography sx={{ fontSize: "0.75rem" }}>
                                        {row.city_name}
                                        {row.state_name ? `, ${row.state_name}` : ""}
                                      </Typography>
                                    </Stack>
                                  </Box>
                                  <IconButton
                                    size="small"
                                    aria-label="Toggle coordinator breakdown"
                                    onClick={() =>
                                      setExpandedId(expanded ? null : row.chpt_id)
                                    }
                                    sx={{
                                      border: expanded ? "1px solid #fde68a" : "1px solid #e2e8f0",
                                      borderRadius: "50%",
                                      width: 30,
                                      height: 30,
                                      flexShrink: 0,
                                      bgcolor: expanded ? "#fef3c7" : "#fff",
                                      color: expanded ? "#92400e" : "#64748b",
                                      "&:hover": { bgcolor: expanded ? "#fde68a" : "#f8fafc" }
                                    }}
                                  >
                                    {expanded ? (
                                      <ExpandLess fontSize="small" />
                                    ) : (
                                      <ExpandMore fontSize="small" />
                                    )}
                                  </IconButton>
                                </Stack>

                                <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", gap: 1 }}>
                                  <Chip
                                    size="small"
                                    label={
                                      isUnassigned
                                        ? "Unassigned"
                                        : `${row.filled_role_count}/${row.total_role_count} filled`
                                    }
                                    sx={{
                                      height: 22,
                                      fontSize: "0.72rem",
                                      fontWeight: 700,
                                      bgcolor: isUnassigned ? "#fef3c7" : "#fffbeb",
                                      color: "#92400e",
                                      border: "1px solid #fde68a"
                                    }}
                                  />
                                  {row.vacant_role_count > 0 ? (
                                    <Chip
                                      size="small"
                                      label={`${row.vacant_role_count} Post${row.vacant_role_count > 1 ? "s" : ""} Empty`}
                                      sx={{
                                        height: 22,
                                        fontSize: "0.72rem",
                                        fontWeight: 700,
                                        bgcolor: "#fef3c7",
                                        color: "#92400e",
                                        border: "1px solid #fde68a"
                                      }}
                                    />
                                  ) : (
                                    <Chip
                                      size="small"
                                      label="All Posts Filled"
                                      sx={{
                                        height: 22,
                                        fontSize: "0.72rem",
                                        fontWeight: 700,
                                        bgcolor: "#f0fdf4",
                                        color: "#15803d"
                                      }}
                                    />
                                  )}
                                  <Chip
                                    size="small"
                                    label={row.ch_status === 0 ? "Active" : "Deactive"}
                                    sx={{
                                      height: 22,
                                      fontSize: "0.72rem",
                                      fontWeight: 700,
                                      bgcolor: row.ch_status === 0 ? "#f1f5f9" : "#fee2e2",
                                      color: row.ch_status === 0 ? "#334155" : "#b91c1c"
                                    }}
                                  />
                                </Stack>

                                <Stack
                                  direction="row"
                                  spacing={1.5}
                                  sx={{ mt: 1.25, color: "#64748b", flexWrap: "wrap", gap: 0.5 }}
                                >
                                  <Stack direction="row" spacing={0.5} alignItems="center">
                                    <Event sx={{ fontSize: 14 }} />
                                    <Typography sx={{ fontSize: "0.73rem" }}>
                                      {row.m_day || "—"}
                                    </Typography>
                                  </Stack>
                                  <Stack direction="row" spacing={0.5} alignItems="center">
                                    <CalendarMonth sx={{ fontSize: 14 }} />
                                    <Typography sx={{ fontSize: "0.73rem" }}>
                                      {row.launch_date || "—"}
                                    </Typography>
                                  </Stack>
                                  {row.launch_director && (
                                    <Stack direction="row" spacing={0.5} alignItems="center">
                                      <Person sx={{ fontSize: 14 }} />
                                      <Typography sx={{ fontSize: "0.73rem" }}>
                                        {row.launch_director}
                                      </Typography>
                                    </Stack>
                                  )}
                                </Stack>

                                {row.vacant_role_count > 0 && !expanded && (
                                  <Box sx={{ mt: 1.25 }}>
                                    <Button
                                      size="small"
                                      variant="text"
                                      onClick={() => setExpandedId(row.chpt_id)}
                                      sx={{
                                        fontSize: "0.72rem",
                                        p: 0,
                                        minWidth: 0,
                                        color: "#d97706",
                                        fontWeight: 600,
                                        textTransform: "none",
                                        "&:hover": { bgcolor: "transparent", color: "#b45309" }
                                      }}
                                    >
                                      See the {row.vacant_role_count} empty post
                                      {row.vacant_role_count > 1 ? "s" : ""} →
                                    </Button>
                                  </Box>
                                )}
                              </Box>

                              <Collapse in={expanded} unmountOnExit>
                                <Box
                                  sx={{
                                    px: 2,
                                    pb: 1.6,
                                    pt: 1.4,
                                    bgcolor: "#fffbeb",
                                    borderTop: "1px solid #fde68a"
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 700,
                                      color: "#92400e",
                                      letterSpacing: "0.04em",
                                      textTransform: "uppercase",
                                      fontSize: "0.68rem",
                                      mb: 1,
                                      display: "block"
                                    }}
                                  >
                                    Posts still waiting for someone — {row.chpt_name}
                                  </Typography>

                                  {(row.roles_breakdown || []).length === 0 ? (
                                    <Typography sx={{ fontSize: "0.75rem", color: "#64748b" }}>
                                      No coordinator roles are configured yet.
                                    </Typography>
                                  ) : (
                                    <>
                                      {vacantRoles.length > 0 && (
                                        <Box sx={{ mb: 1.25 }}>
                                          <Typography
                                            sx={{
                                              fontSize: "0.68rem",
                                              fontWeight: 700,
                                              textTransform: "uppercase",
                                              letterSpacing: "0.04em",
                                              color: "#92400e",
                                              mb: 0.6
                                            }}
                                          >
                                            Vacant ({vacantRoles.length})
                                          </Typography>
                                          <Stack direction="row" flexWrap="wrap" gap={0.8}>
                                            {vacantRoles.map((b) => (
                                              <Chip
                                                key={`v-${b.role_id}`}
                                                size="small"
                                                label={b.role_name}
                                                onClick={() =>
                                                  navigate(`/allocate-post/${row.chpt_id}`)
                                                }
                                                sx={{
                                                  bgcolor: "#fff",
                                                  border: "1px solid #f59e0b",
                                                  fontWeight: 600,
                                                  color: "#92400e",
                                                  cursor: "pointer",
                                                  height: 24,
                                                  fontSize: "0.72rem"
                                                }}
                                              />
                                            ))}
                                          </Stack>
                                        </Box>
                                      )}

                                      {filledRoles.length > 0 && (
                                        <Box>
                                          <Typography
                                            sx={{
                                              fontSize: "0.68rem",
                                              fontWeight: 700,
                                              textTransform: "uppercase",
                                              letterSpacing: "0.04em",
                                              color: "#64748b",
                                              mb: 0.6
                                            }}
                                          >
                                            Filled ({filledRoles.length})
                                          </Typography>
                                          <Stack direction="row" flexWrap="wrap" gap={0.8}>
                                            {filledRoles.map((b) => (
                                              <Chip
                                                key={`f-${b.role_id}`}
                                                size="small"
                                                label={b.role_name}
                                                sx={{
                                                  bgcolor: "#fff",
                                                  border: "1px solid #e2e8f0",
                                                  fontWeight: 600,
                                                  color: "#475569",
                                                  height: 24,
                                                  fontSize: "0.72rem"
                                                }}
                                              />
                                            ))}
                                          </Stack>
                                        </Box>
                                      )}
                                    </>
                                  )}
                                </Box>
                              </Collapse>

                              <Divider />

                              <Stack
                                direction="row"
                                spacing={0}
                                flexWrap="wrap"
                                sx={{
                                  px: 1.6,
                                  py: 1.2,
                                  mt: "auto",
                                  borderTop: "1px solid #f1f5f9",
                                  bgcolor: "#f8fafc",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  rowGap: 0.5
                                }}
                              >
                                {(loginUser.u_type == 0 ||
                                  (loginUser.u_type == 2 && loginUser.p_user_id == 1)) && (
                                  <Tooltip title="Set Meeting Dates">
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        getMeetingDate(row.metting_day, row.chpt_id);
                                        setMyModal(true);
                                      }}
                                    >
                                      <CalendarMonth fontSize="small" color="info" />
                                    </IconButton>
                                  </Tooltip>
                                )}
                                <Tooltip title="Edit Chapter">
                                  <IconButton size="small" onClick={() => getchapt(row.chpt_id)}>
                                    <EditSharp fontSize="small" color="warning" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Allocate Post">
                                  <IconButton
                                    size="small"
                                    onClick={() => navigate(`/allocate-post/${row.chpt_id}`)}
                                  >
                                    <AssignmentInd fontSize="small" color="success" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Manage Directors">
                                  <IconButton
                                    size="small"
                                    onClick={() => navigate(`/chapter-directors/${row.chpt_id}`)}
                                  >
                                    <BadgeIcon fontSize="small" color="primary" />
                                  </IconButton>
                                </Tooltip>
                                {loginUser?.u_type != 2 && loginUser?.u_type != 1 && (
                                  <>
                                    <Tooltip title="View History">
                                      <IconButton
                                        size="small"
                                        onClick={() => {
                                          setActiveChapterId(row.chpt_id);
                                          getChapterHistoryById(row.chpt_id, row.chpt_name);
                                        }}
                                      >
                                        <VisibilityRounded fontSize="small" color="primary" />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title={row.ch_status === 0 ? "De-Active" : "Activate"}>
                                      <IconButton
                                        size="small"
                                        onClick={() => {
                                          setActiveChapterId(row.chpt_id);
                                          row.ch_status === 0
                                            ? setIsOpenDeActiveModal(true)
                                            : setIsOpenReDeactivateModal(true);
                                        }}
                                      >
                                        {row.ch_status === 0 ? (
                                          <DeleteOutline fontSize="small" color="error" />
                                        ) : (
                                          <CheckCircleOutline fontSize="small" color="success" />
                                        )}
                                      </IconButton>
                                    </Tooltip>
                                  </>
                                )}
                              </Stack>
                            </Card>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </>
                )}
              </Box>

              {chapterRows.length > 0 && (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ mt: 2, flexWrap: "wrap", gap: 1.5, p: 1 }}
                >
                  <Stack direction="row" alignItems="center" spacing={1.2}>
                    <Typography variant="caption" sx={{ color: "#64748b" }}>
                      Rows per page:
                    </Typography>
                    <FormControl size="small" sx={{ minWidth: 80 }}>
                      <MuiSelect
                        value={perPage}
                        onChange={(e) => {
                          setPerPage(e.target.value);
                          setPage(1);
                        }}
                        size="small"
                        sx={{ height: 32, fontSize: "0.8rem", borderRadius: "8px", bgcolor: "#fff" }}
                      >
                        {[10, 25, 50, 100].map((n) => (
                          <MenuItem key={n} value={n} sx={{ fontSize: "0.8rem" }}>
                            {n}
                          </MenuItem>
                        ))}
                      </MuiSelect>
                    </FormControl>
                    <Typography variant="caption" sx={{ color: "#475569", ml: 1 }}>
                      {counter === 0
                        ? "0 of 0"
                        : `${(page - 1) * perPage + 1}-${Math.min(page * perPage, counter)} of ${counter}`}
                    </Typography>
                  </Stack>
                  <Pagination
                    count={Math.max(1, Math.ceil(counter / perPage))}
                    page={page}
                    onChange={(_, p) => setPage(p)}
                    color="primary"
                    size="small"
                    showFirstButton
                    showLastButton
                    sx={{
                      "& .MuiPaginationItem-root": { fontSize: "0.8rem", borderRadius: "8px" },
                      "& .Mui-selected": {
                        bgcolor: "#0f172a",
                        color: "#fff",
                        "&:hover": { bgcolor: "#1e293b" }
                      }
                    }}
                  />
                </Stack>
              )}
            </Card>
          )}
        </Container>
      </Page>
    </>
  );
}
